import { Select as DSSelect, SelectProps as DSSelectProps } from '@axafr-btc-ds/form-select';
import styles from './Select.module.css';

export const Select = (props: DSSelectProps) => {
    return (
        <DSSelect
            { ...props }
            labelClassName={ !props.label ? styles.label : '' }
            className={ styles.container }
            parentClassname={ styles.select }
            hasError={ false }
        />
    );
};
